import { FC } from "react";

import {
  SHEET_CHILDREN_CLASS,
  SHEET_CONTENT_VARIANT_CLASS_MAP,
  SHEET_ROOT_DEFAULTS,
  TSheetChildrenProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";
import { cn } from "@/ui/lib";

export const SheetChildren: FC<TSheetChildrenProps> = ({
  children,
  contentVariant = SHEET_ROOT_DEFAULTS.contentVariant,
}) => {
  if (!children) { return null; }
  return (
    <div
      data-component="SheetChildren"
      className={cn(
        SHEET_CHILDREN_CLASS,
        SHEET_CONTENT_VARIANT_CLASS_MAP[contentVariant],
      )}
    >
      { children }
    </div>
  );
};
